var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-container",
    { attrs: { id: "accounts-view", tag: "section" } },
    [
      _c(
        "v-card",
        [
          _c(
            "v-card-title",
            [
              _c(
                "v-row",
                [
                  _c("v-col", { attrs: { cols: "12", sm: "8", md: "6" } }, [
                    _vm._v(" " + _vm._s(_vm.$t("account.accounts")) + " ")
                  ]),
                  _c(
                    "v-col",
                    {
                      staticClass: "text-sm-right",
                      attrs: { cols: "12", sm: "4", md: "6" }
                    },
                    [
                      _c(
                        "v-btn",
                        {
                          attrs: { color: "primary" },
                          on: { click: _vm.createItemDialog }
                        },
                        [
                          _vm._v(
                            " " + _vm._s(_vm.$t("account.create-account")) + " "
                          )
                        ]
                      ),
                      _c(
                        "v-btn",
                        {
                          attrs: {
                            color: "secondary",
                            "aria-label": _vm.$t("account.refresh-accounts")
                          },
                          on: {
                            click: function($event) {
                              return _vm.refreshItems(true)
                            }
                          }
                        },
                        [_c("v-icon", [_vm._v("mdi-refresh")])],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _c(
            "v-card-text",
            [
              _c(
                "v-row",
                [
                  _c(
                    "v-col",
                    [
                      _c("v-text-field", {
                        staticClass: "searchBox",
                        attrs: {
                          "append-icon": "mdi-magnify",
                          "aria-label":
                            _vm.$t("global.text-field") +
                            " " +
                            _vm.$t("global.search") +
                            " " +
                            _vm.$t("account.accounts"),
                          "single-line": "",
                          "hide-details": ""
                        },
                        model: {
                          value: _vm.search,
                          callback: function($$v) {
                            _vm.search = $$v
                          },
                          expression: "search"
                        }
                      })
                    ],
                    1
                  ),
                  _c("v-spacer"),
                  _c("v-spacer"),
                  _c("v-spacer"),
                  _c(
                    "v-col",
                    [
                      _c("v-switch", {
                        attrs: { label: _vm.$t("accounts.hide-expired") },
                        model: {
                          value: _vm.filterOutExpiredAccounts,
                          callback: function($$v) {
                            _vm.filterOutExpiredAccounts = $$v
                          },
                          expression: "filterOutExpiredAccounts"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              ),
              _c("v-data-table", {
                attrs: {
                  filterable: "",
                  headers: _vm.headersForUser,
                  items: _vm.items,
                  "item-key": "id",
                  loading: _vm.loading,
                  search: _vm.search,
                  "items-per-page": 30,
                  "footer-props": {
                    "items-per-page-options": [15, 30, 50, 100, -1]
                  }
                },
                scopedSlots: _vm._u([
                  {
                    key: "item.displayName",
                    fn: function(ref) {
                      var item = ref.item
                      return [
                        _c(
                          "a",
                          {
                            attrs: { href: _vm.createAccountDashboardURL(item) }
                          },
                          [_vm._v(" " + _vm._s(item.displayName) + " ")]
                        )
                      ]
                    }
                  },
                  {
                    key: "item.status",
                    fn: function(ref) {
                      var item = ref.item
                      return [
                        _c(
                          "v-chip",
                          {
                            staticClass: "status",
                            class: [_vm.getDisplayStatus(item)]
                          },
                          [
                            _vm._v(
                              " " +
                                _vm._s(_vm.$t(_vm.getDisplayStatusText(item))) +
                                " "
                            )
                          ]
                        )
                      ]
                    }
                  },
                  {
                    key: "item.created",
                    fn: function(ref) {
                      var item = ref.item
                      return [
                        _vm._v(
                          " " + _vm._s(_vm.displayTime(item.created)) + " "
                        )
                      ]
                    }
                  },
                  {
                    key: "item.expires",
                    fn: function(ref) {
                      var item = ref.item
                      return [
                        _vm._v(
                          " " + _vm._s(_vm.displayTime(item.expires)) + " "
                        )
                      ]
                    }
                  },
                  {
                    key: "item.accountType",
                    fn: function(ref) {
                      var item = ref.item
                      return [
                        _vm._v(
                          " " +
                            _vm._s(_vm.$t("accountType." + item.accountType)) +
                            " "
                        )
                      ]
                    }
                  },
                  {
                    key: "item.managingAccountID",
                    fn: function(ref) {
                      var item = ref.item
                      return [
                        _vm._v(
                          " " +
                            _vm._s(
                              _vm.ownerAccountName(item.managingAccountID)
                            ) +
                            " "
                        )
                      ]
                    }
                  },
                  {
                    key: "item.actions",
                    fn: function(ref) {
                      var item = ref.item
                      return [
                        item.status !== "deleted"
                          ? _c(
                              "v-tooltip",
                              {
                                attrs: { bottom: "" },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "activator",
                                      fn: function(ref) {
                                        var on = ref.on
                                        return [
                                          _c(
                                            "v-icon",
                                            _vm._g(
                                              {
                                                staticClass: "mr-2",
                                                attrs: {
                                                  "aria-label": _vm.$t(
                                                    "account.edit.edit-account",
                                                    [item.displayName]
                                                  )
                                                },
                                                on: {
                                                  click: function($event) {
                                                    return _vm.editItem(item)
                                                  }
                                                }
                                              },
                                              on
                                            ),
                                            [_vm._v(" mdi-pencil-outline ")]
                                          )
                                        ]
                                      }
                                    }
                                  ],
                                  null,
                                  true
                                )
                              },
                              [_c("span", [_vm._v(_vm._s(_vm.$t("edit")))])]
                            )
                          : _vm._e(),
                        _c(
                          "v-tooltip",
                          {
                            attrs: { bottom: "" },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "activator",
                                  fn: function(ref) {
                                    var on = ref.on
                                    return [
                                      _c(
                                        "v-icon",
                                        _vm._g(
                                          {
                                            attrs: {
                                              "aria-label":
                                                item.status !== "deleted"
                                                  ? _vm.$t(
                                                      "account.edit.delete-account",
                                                      [item.displayName]
                                                    )
                                                  : _vm.$t(
                                                      "account.edit.revert-delete-account",
                                                      [item.displayName]
                                                    )
                                            },
                                            on: {
                                              click: function($event) {
                                                return _vm.deleteItem(item)
                                              }
                                            }
                                          },
                                          on
                                        ),
                                        [
                                          _vm._v(
                                            " " +
                                              _vm._s(
                                                item.status === "deleted"
                                                  ? "mdi-delete-off-outline"
                                                  : "mdi-delete-outline"
                                              ) +
                                              " "
                                          )
                                        ]
                                      )
                                    ]
                                  }
                                }
                              ],
                              null,
                              true
                            )
                          },
                          [
                            [
                              item.status !== "deleted"
                                ? _c("span", [_vm._v(_vm._s(_vm.$t("delete")))])
                                : _c("span", [
                                    _vm._v(_vm._s(_vm.$t("revert-delete")))
                                  ])
                            ]
                          ],
                          2
                        )
                      ]
                    }
                  }
                ]),
                model: {
                  value: _vm.selected,
                  callback: function($$v) {
                    _vm.selected = $$v
                  },
                  expression: "selected"
                }
              })
            ],
            1
          )
        ],
        1
      ),
      _c(
        "v-row",
        { attrs: { justify: "center" } },
        [
          _c(
            "v-dialog",
            {
              attrs: { persistent: "", "max-width": "600px" },
              model: {
                value: _vm.editDialogVisible,
                callback: function($$v) {
                  _vm.editDialogVisible = $$v
                },
                expression: "editDialogVisible"
              }
            },
            [
              _c("account-view", {
                ref: "accountEditDialog",
                attrs: { id: _vm.editedItemID, model: _vm.editedItem },
                on: {
                  cancel: _vm.closeEditDialog,
                  save: _vm.saveEditDialog,
                  error: _vm.errorDialog
                }
              })
            ],
            1
          ),
          _c(
            "v-dialog",
            {
              attrs: { "max-width": "500px" },
              model: {
                value: _vm.deleteDialogVisible,
                callback: function($$v) {
                  _vm.deleteDialogVisible = $$v
                },
                expression: "deleteDialogVisible"
              }
            },
            [
              _c(
                "v-card",
                [
                  _c("v-card-title", [
                    _vm._v(_vm._s(_vm.$t("global.confirm")))
                  ]),
                  _c("v-card-text", [
                    _vm.editedItem && _vm.editedItem.status !== "deleted"
                      ? _c("span", [
                          _vm._v(_vm._s(_vm.$t("account.confirm-delete")) + " ")
                        ])
                      : _vm._e(),
                    _vm.editedItem && _vm.editedItem.status === "deleted"
                      ? _c("span", [
                          _vm._v(
                            _vm._s(_vm.$t("account.confirm-revert-delete")) +
                              " "
                          )
                        ])
                      : _vm._e(),
                    _c("span", { staticClass: "font-weight-bold" }, [
                      _vm._v(_vm._s(_vm.selectedAccountName))
                    ]),
                    _vm._v("? ")
                  ]),
                  _c(
                    "v-card-actions",
                    [
                      _c("v-spacer"),
                      _c(
                        "v-btn",
                        {
                          attrs: { color: "blue" },
                          on: { click: _vm.closeDeleteDialog }
                        },
                        [_vm._v(" " + _vm._s(_vm.$t("global.no")) + " ")]
                      ),
                      _c(
                        "v-btn",
                        {
                          attrs: { color: "red" },
                          on: { click: _vm.confirmDeleteItem }
                        },
                        [_vm._v(" " + _vm._s(_vm.$t("global.yes")) + " ")]
                      ),
                      _c("v-spacer")
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _c(
        "v-dialog",
        {
          attrs: { "max-width": "500px" },
          model: {
            value: _vm.error,
            callback: function($$v) {
              _vm.error = $$v
            },
            expression: "error"
          }
        },
        [
          _c(
            "v-card",
            [
              _c("v-card-title", [_vm._v(_vm._s(_vm.$t("global.error")))]),
              _c("v-card-text", [_vm._v(_vm._s(_vm.errorMsg))]),
              _c(
                "v-card-actions",
                [
                  _c("v-spacer"),
                  _c(
                    "v-btn",
                    {
                      attrs: { color: "blue" },
                      on: {
                        click: function($event) {
                          _vm.error = null
                        }
                      }
                    },
                    [_vm._v(" " + _vm._s(_vm.$t("global.close")) + " ")]
                  ),
                  _c("v-spacer")
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _c(
        "v-overlay",
        { attrs: { value: _vm.busy } },
        [
          _c("v-progress-circular", {
            attrs: { indeterminate: "", size: "64" }
          })
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }